const UNICODE_WHITESPACE_SEQUENCE = /[\p{White_Space}\uFEFF]+/gu;
const SURROUNDING_UNICODE_WHITESPACE =
  /^[\p{White_Space}\uFEFF]+|[\p{White_Space}\uFEFF]+$/gu;
const EMAIL_PATTERN = /^[^\p{White_Space}\uFEFF@]+@[^\p{White_Space}\uFEFF@]+\.[^\p{White_Space}\uFEFF@]+$/u;
const SENSITIVE_DIGITS_PATTERN = /^\d{11,14}$/u;

export function normalizeQuery(input: string): string {
  return input
    .replace(SURROUNDING_UNICODE_WHITESPACE, "")
    .replace(UNICODE_WHITESPACE_SEQUENCE, " ");
}

export function unicodeLength(input: string): number {
  return Array.from(input).length;
}

export function isSensitiveQuery(input: string): boolean {
  const normalized = normalizeQuery(input);
  return EMAIL_PATTERN.test(normalized) || SENSITIVE_DIGITS_PATTERN.test(normalized);
}
